var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"service-form-part"},[_c('ServiceRadioField',_vm._g({attrs:{"choices":_vm.services}},_vm.$listeners))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }